export enum ProformaSubNavItems {
  SOURCE_AND_USES = "sources-and-uses",
  DEVELOPMENT_BUDGET = "development-budget",
  RENTAL_INCOME = "rental-income",
  INCOME_AND_OPEX = "income-and-opex",
  PL_PROJECTIONS = "pl-projections",
  OTHER_DATA = "other-data",
}
